import state from "@/store/modules/var/state";
import mutations from "@/store/modules/var/mutations";
import actions from "@/store/modules/var/actions";

export default {
    state,
    mutations,
    actions
}